import { render, staticRenderFns } from "./position-importer-page.vue?vue&type=template&id=1a91bc4d&"
import script from "./position-importer-page.vue?vue&type=script&lang=js&"
export * from "./position-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports